
import { HorseModel } from '../../../model/horse/HorseModel';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { WebSocketService } from '../../../services/webSocketService';
import { CustomStorageProvider } from '../../custom-storage/custom-storage';
import { Constants, RaceTrack,RaceCourse,RaceDistance, RaceClass } from '../../../util/Constants';
import { HorseRaceModel } from '../../../model/horse/HorseRaceModel';
import { HorseDataConverterProvider } from '../horse-data-converter/horse-data-converter';
import { Util } from '../../../util/Util';
import { Race } from '../../../model/Race';
import { race } from 'rxjs/operator/race';


/*
  Generated class for the HorseRaceDataProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class HorseRaceDataProvider {
  lastStartedRaceId: number;
  lastEndedRaceId: number;

  constructor(private webSocketService: WebSocketService, private customStorageProvider: CustomStorageProvider, private horseDataConverterProvider: HorseDataConverterProvider) {
    this.lastStartedRaceId = -1;
    this.lastEndedRaceId = -1;
  }

  public getRaceStatus(raceId: number) {
    if (this.lastStartedRaceId <= 0 || this.lastStartedRaceId < raceId) {
      return HORSE_RACE_STATUS.HORSE_RACE_NOT_STARTED;
    } else if (this.lastStartedRaceId == raceId && this.lastEndedRaceId != raceId) {
      return HORSE_RACE_STATUS.HORSE_RACE_START_SOON;
    } else {
      return HORSE_RACE_STATUS.HORSE_RACE_ENDED;
    }
  }

  public getRaceCards(includeTipsPackage: boolean = true): Promise<Array<HorseRaceModel>> {
    let langName = this.customStorageProvider.get<string>(Constants.STORAGE_KEY_LANG);
    return this.processDataFromServer(this.webSocketService.getHorseRaceCards(langName, true), langName, includeTipsPackage);
  }

  private processDataFromServer(promise: Promise<any>, langName: string, includeTipsPackage: boolean = true): Promise<Array<HorseRaceModel>> {
    return new Promise<Array<HorseRaceModel>>((resolve, reject) => {
      promise.then(response => {
        this.lastStartedRaceId = response.lastStartedRaceId;
        this.lastEndedRaceId = response.lastEndedRaceId;

        let raceCards: Array<HorseRaceModel>;
        if (response.RaceCard != null && response.RaceCard.length > 1) {
          raceCards = this.horseDataConverterProvider.convertRawDataToRaceCards(response.RaceCard, false);
          this.customStorageProvider.set(Constants.STORAGE_KEY_RACE_CARDS, raceCards);
          if (response.lastModified != null) {
            this.customStorageProvider.set(Constants.STORAGE_KEY_RACE_CARDS_LAST_MODIFIED, response.lastModified);
          }
          if (includeTipsPackage) {
            raceCards.unshift(new HorseRaceModel(0, 0, raceCards[0].raceName, raceCards[0].raceDistance,
              raceCards[0].raceDate, raceCards[0].raceTime, raceCards[0].raceCourse, raceCards[0].raceClass,
              raceCards[0].raceTrack, raceCards[0].raceTrackCondition, raceCards[0].horses, raceCards[0].hasP, raceCards[0].hasQ, raceCards[0].hasQP, raceCards[0].raceTips, raceCards[0].keyRace));
          }

          resolve(raceCards);
          return;
        } else {
          raceCards = this.customStorageProvider.get<Array<HorseRaceModel>>(Constants.STORAGE_KEY_RACE_CARDS);
          let raceCardLastModified = this.customStorageProvider.get(Constants.STORAGE_KEY_RACE_CARDS_LAST_MODIFIED);
          if (raceCardLastModified != response.lastModified || raceCards == null) {
            if (response.lastModified != null) {
              this.customStorageProvider.set(Constants.STORAGE_KEY_RACE_CARDS_LAST_MODIFIED, response.lastModified);
            }
            resolve(this.processDataFromServer(this.webSocketService.getHorseRaceCards(langName, false), langName, includeTipsPackage));
          } else {
            if (includeTipsPackage) {
              raceCards.unshift(new HorseRaceModel(0, 0, raceCards[0].raceName, raceCards[0].raceDistance,
                raceCards[0].raceDate, raceCards[0].raceTime, raceCards[0].raceCourse, raceCards[0].raceClass,
                raceCards[0].raceTrack, raceCards[0].raceTrackCondition, raceCards[0].horses, raceCards[0].hasP, raceCards[0].hasQ, raceCards[0].hasQP, raceCards[0].raceTips, raceCards[0].keyRace));
            }

            resolve(raceCards);
            return;
          }
        }
      }
        , err => {
          reject(err);
        })
    });
  }

  public getRacesInfo(): Array<Race> {
    let raceCards = this.customStorageProvider.get<Array<HorseRaceModel>>(Constants.STORAGE_KEY_RACE_CARDS);
    console.log("Horse Race Data - Get Races Info");
    console.table(raceCards);
      let raceList = new Array<Race>();
      for(let raceCard of raceCards){
          let race: Race = <Race>{};
          race.RaceID = raceCard.raceId;
          race.RaceNum = raceCard.raceNum;
          race.KeyRace = raceCard.keyRace;
          race.Class = RaceClass[raceCard.raceClass];
          //let dRaceDate = Util.createDateFromString(race.RaceDate);
          race.FormattedRaceDate = Util.convertDate2DDMMYY(raceCard.raceDate.split(" ")[0]);
          race.FormattedRaceTrack = Util.getRaceTrack(RaceTrack[raceCard.raceTrack]);
          // console.log("GetRacesInfo" + JSON.stringify(race));
          race.raceCourseDisplayed = Util.getRaceCourseDisplayed(RaceCourse[raceCard.raceCourse], RaceTrack[raceCard.raceTrack], RaceDistance[raceCard.raceDistance]);
          raceList.push(race);
      }
        return(raceList);
  }

  public getHorse(raceNum: number, horseNum: number): HorseModel {
    let raceCards = this.customStorageProvider.get<Array<HorseRaceModel>>(Constants.STORAGE_KEY_RACE_CARDS);
    for (let raceCard of raceCards) {
      if (raceCard.raceNum == raceNum) {
        for (let horse of raceCard.horses) {
          if (horse.num == horseNum) {
            return horse;
          }
        }
      }
    }
    return null;
  }

  public getRaceNum(raceId: number): number {
    let raceCards = this.customStorageProvider.get<Array<HorseRaceModel>>(Constants.STORAGE_KEY_RACE_CARDS);
    return Util.getRaceNum(raceCards, raceId);
  }

  public getRaceId(raceNum: number): number {
    let raceCards = this.customStorageProvider.get<Array<HorseRaceModel>>(Constants.STORAGE_KEY_RACE_CARDS);
    return Util.getRaceId(raceCards, raceNum);
  }

  public getActiveRaceNum(): number {
    let raceCards = this.customStorageProvider.get<Array<HorseRaceModel>>(Constants.STORAGE_KEY_RACE_CARDS);
    let firstRaceDateTime = new Date(Util.convertStringToDate(raceCards[0].raceDate  + " " + raceCards[0].raceTime + ":00"));
    //firstRaceDateTime = new Date("2017-09-04T10:52:00");
    let now = new Date();

    if (this.lastStartedRaceId < raceCards[0].raceId) {
      this.lastStartedRaceId = -1;
    }

    if (this.lastEndedRaceId < raceCards[0].raceId) {
      this.lastEndedRaceId = -1;
    }

    let minToFirstRace = (firstRaceDateTime.getTime() - now.getTime())/1000/60;

    if (minToFirstRace > 0 && minToFirstRace < 30) {
      return 1;
    } if (this.lastStartedRaceId == -1 && this.lastEndedRaceId == -1) { // case 1, no match started
      return 0;
    } else if (this.lastStartedRaceId != -1 && this.lastEndedRaceId == -1) { // case 2, only first match is started
      return this.getRaceNum(this.lastStartedRaceId);
    } else if (this.lastEndedRaceId == raceCards[raceCards.length - 1].raceId) { // case 3, all races are ended, back to tips package
      return 0;
    } else { // case 4, one of the races is ended
      let targetRaceNum: number = this.getRaceNum(this.lastEndedRaceId);
      targetRaceNum++;
      targetRaceNum = Math.min(targetRaceNum, raceCards[raceCards.length - 1].raceNum);

      return targetRaceNum;
    }

  }

}

export enum HORSE_RACE_STATUS { HORSE_RACE_NOT_STARTED, HORSE_RACE_START_SOON, HORSE_RACE_ENDED };



// WEBPACK FOOTER //
// ./src/providers/horse/horse-race-data/horse-race-data.ts